import React, { useEffect } from "react";
import { Select } from "antd";
import { createComponentStore } from "easy-peasy";
import {
  ParameterStoreModel,
  ACTION_TYPES,
} from "store/models/parameters/general-parameter";

const useConditionTypeStore = createComponentStore(
  ParameterStoreModel("conditiontype")
);

export default function ConditionTypeSelect({ ...props }) {
  const [store, actions] = useConditionTypeStore();

  useEffect(() => {
    actions.fetch();
  }, []);

  return (
    <Select
      loading={store.process === ACTION_TYPES.FETCHING_DATA}
      allowClear={true}
      onChange={(value) => {
        value = value = store.data?.find((f) => f.id == value);
        props.onChange(value);
      }}
      value={props.value?.id}
    >
      <Select.Option key={null} value={null}></Select.Option>
      {store.data.map((item) => {
        return (
          <Select.Option
            key={item.id}
            value={item.id}
            disabled={item.id === props?.record.id}
          >
            {item.description}
          </Select.Option>
        );
      })}
    </Select>
  );
}
